/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuotaSnapshotFromJSON, QuotaSnapshotToJSON } from './QuotaSnapshot';
import { SubscriptionSnapshotFromJSON, SubscriptionSnapshotToJSON } from './SubscriptionSnapshot';
/**
 * Check if a given object implements the SessionInitResponse interface.
 */
export function instanceOfSessionInitResponse(value) {
    if (!('degraded' in value) || value['degraded'] === undefined)
        return false;
    if (!('quota' in value) || value['quota'] === undefined)
        return false;
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    if (!('subscription' in value) || value['subscription'] === undefined)
        return false;
    return true;
}
export function SessionInitResponseFromJSON(json) {
    return SessionInitResponseFromJSONTyped(json, false);
}
export function SessionInitResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'degraded': json['degraded'],
        'quota': QuotaSnapshotFromJSON(json['quota']),
        'reason': json['reason'],
        'subscription': SubscriptionSnapshotFromJSON(json['subscription']),
    };
}
export function SessionInitResponseToJSON(json) {
    return SessionInitResponseToJSONTyped(json, false);
}
export function SessionInitResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'degraded': value['degraded'],
        'quota': QuotaSnapshotToJSON(value['quota']),
        'reason': value['reason'],
        'subscription': SubscriptionSnapshotToJSON(value['subscription']),
    };
}
